import { css } from '@emotion/react';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const mainContainerStyles = css`
  display: flex;
  flex-direction: column;
  margin: var(${SpacingToken.Spacing3});
  padding: var(${SpacingToken.Spacing6}) var(${SpacingToken.Spacing4});
  overflow: hidden;
  border-radius: 10px;
  background: var(${DesignToken.SurfacePrimaryDefault});
`;

export const productListContainer = css`
  display: grid;
  grid-template-columns: 1fr;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing3});

  ${MEDIA_MIN_SM} {
    grid-template-columns: 0.8fr 1fr;
    gap: var(${SpacingToken.Spacing4});
  }
`;

export const buttonStyles = css`
  width: 48px;
  min-height: 48px;
  color: var(${DesignToken.ContentBasicPrimary});
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(${RadiusToken.Radius3});

  > span {
    width: fit-content;
    height: 24px;
  }

  &:hover {
    color: var(${DesignToken.ContentBasicPrimary});
    background: var(${DesignToken.SurfaceSecondaryDefault});
  }
`;

export const headerStyles = css`
  text-align: left;
  margin-top: var(${SpacingToken.Spacing1});
  margin-bottom: var(${SpacingToken.Spacing2});
  margin-left: var(${SpacingToken.Spacing4});
  color: var(${DesignToken.ContentBasicDisabled});
`;

export const popoverStyles = css`
  max-width: unset;
  width: 340px;

  ${MEDIA_MIN_SM} {
    width: 640px;
  }
`;
